const state = {
    stateUpdated:1
}

const getters = {
    stateUpdated: (state) => {
        return state.stateUpdated;
    },
}

const actions = {
}

const mutations = {
    closeNav(state) {
        state.stateUpdated++;
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js